var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4425 7.125H11.25V3.375C11.25 2.9625 10.9125 2.625 10.5 2.625H7.5C7.0875 2.625 6.75 2.9625 6.75 3.375V7.125H5.5575C4.89 7.125 4.5525 7.935 5.025 8.4075L8.4675 11.85C8.76 12.1425 9.2325 12.1425 9.525 11.85L12.9675 8.4075C13.44 7.935 13.11 7.125 12.4425 7.125ZM3.75 14.625C3.75 15.0375 4.0875 15.375 4.5 15.375H13.5C13.9125 15.375 14.25 15.0375 14.25 14.625C14.25 14.2125 13.9125 13.875 13.5 13.875H4.5C4.0875 13.875 3.75 14.2125 3.75 14.625Z",
    fill: "#002D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.47f88e559c060de053bd2b2b6ace3cd0.svg";
export { ForwardRef as ReactComponent };